"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HeaderMenu;

var _Menu2 = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem2 = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _Delete2 = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _FileCopy2 = _interopRequireDefault(require("@material-ui/icons/FileCopy"));

var _Category2 = _interopRequireDefault(require("@material-ui/icons/Category"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var menus = [{
  key: "customize",
  label: "Costumize field type",
  icon: /*#__PURE__*/_react["default"].createElement(_Category2["default"], {
    fontSize: "small"
  })
}, {
  key: "duplicate",
  label: "Duplicate field",
  icon: /*#__PURE__*/_react["default"].createElement(_FileCopy2["default"], {
    fontSize: "small"
  })
}, {
  key: "delete",
  label: "Delete field",
  icon: /*#__PURE__*/_react["default"].createElement(_Delete2["default"], {
    fontSize: "small"
  })
}];
HeaderMenu.propTypes = {
  onSave: _propTypes["default"].func,
  column: _propTypes["default"].object
};

function HeaderMenu(_ref) {
  var column = _ref.column;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleClick = function handleClick(event) {
    var resolvedAnchorEl = event.currentTarget.getBoundingClientRect();

    var anchorEl = function anchorEl() {
      return {
        nodeType: 1,
        getBoundingClientRect: function getBoundingClientRect() {
          return resolvedAnchorEl;
        }
      };
    };

    setAnchorEl(anchorEl);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleSelect = function handleSelect(item) {
    handleClose();
    var anchor = anchorEl;
    column.setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        openHeaderMenu: anchor,
        key: item.key,
        column: column
      });
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
    size: "small",
    "aria-controls": "simple-menu",
    "aria-haspopup": "true",
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], {
    fontSize: "small"
  })), /*#__PURE__*/_react["default"].createElement(_Menu2["default"], {
    id: "menu",
    anchorEl: anchorEl,
    keepMounted: true,
    variant: "menu",
    open: Boolean(anchorEl),
    onClose: handleClose,
    getContentAnchorEl: null,
    disableAutoFocus: true,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, menus.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
      key: item.key,
      onClick: function onClick() {
        return handleSelect(item);
      }
    }, item.icon, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      ml: 1
    }), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, item.label));
  })));
}